export const BuildInfo = {timestamp:1783105904000}
